import React, {PureComponent} from 'react';
import {Link} from 'react-router-dom';
import {getPromoLinkPath} from 'app/utils';
import {i18n_t} from 'app/i18n';
import ClickableTooltip from 'app/components/reusable/ClickableTooltip';
import {goToMyHero} from 'app/utils/app_links';
import ConvertButton from 'app/components/my_profile/artifacts/artifact_popup/compendium/ConvertButton';
import SpriteIcon from 'app/utils/sprites/SpriteIcon';

interface AsideLinksProps {
    predictions_available: number
    prediction_points: number
    scatterText: string
}

export default class AsideLinks extends PureComponent<AsideLinksProps> {
    render(): React.ReactNode {
        const {prediction_points, predictions_available, scatterText} = this.props;

        return <div className="compendium-aside__links">
            <div className="compendium-aside__link">
                <SpriteIcon name="#svg-predictions"size={{height: 16, width: 16}}/>
                <Link
                    to={getPromoLinkPath('/predictions')}
                >
                    {`${i18n_t('compendium.compendium_table')} (${predictions_available})`}
                </Link>
            </div>
            <div className="compendium-aside__link">
                <SpriteIcon name="#svg-my-predictions" size={{height: 16, width: 16}}/>
                <Link
                    to={getPromoLinkPath('/my_predictions')}
                >
                    {i18n_t('compendium.my_predictions', {count: prediction_points})}
                </Link>
            </div>
            <div className="compendium-aside__link">
                <SpriteIcon name="#svg-table-leaders" className="svg-default"/>
                <Link
                    to={getPromoLinkPath('/rating')}
                >
                    {i18n_t('compendium.results_table')}
                </Link>
            </div>
            <div className="compendium-aside__link">
                <SpriteIcon name="#svg-scatter" size={{height: 16, width: 16}}/>
                <ConvertButton onClickHandler={goToMyHero} classes={['compendium-aside__scatter-btn']}/>
                <ClickableTooltip text={scatterText}/>
            </div>
        </div>;
    }
}
